import React from 'react';
import { Input, InputProps } from '@fx-ui/fine-design';
import classNames from 'classnames';
import { isNil, parseNumber, str2num } from '@libs/shared';

interface INumberProps {
    className?: string;
    placeholder?: string;
    readonly?: boolean;
    value?: number;
    onChange?: (val: number | null) => void;
    style?: React.CSSProperties;
    disabled?: boolean;
    inputState?: InputProps['inputState'];
}

const Number: React.FunctionComponent<INumberProps> = (props) => {
    const { className, placeholder, readonly, value, inputState, onChange, style, disabled } =
        props;

    const format = (val?: number) => {
        let result: any = parseNumber(val);
        if (isNil(result)) {
            result = '';
        }
        return result;
    };

    return (
        <Input
            className={classNames('fx-number', className)}
            style={style}
            inputState={inputState}
            readonly={readonly}
            disabled={disabled}
            type="number"
            placeholder={placeholder}
            value={format(value)}
            onChange={(val) => onChange && onChange(str2num(val))}
        />
    );
};

export default Number;
